import { FEATURE_PER_FAMILY, PlanFamily, ProductFeature } from '@localstack/types';
import { FAMILIES_PRICING_ORDER } from '@localstack/constants';

export const hasFeatureBase = (
  featureNames: ProductFeature[],
  featureVariants: string[],
  feature: ProductFeature,
  variant?: string,
): boolean => {
  const conditions: boolean[] = [];

  conditions.push(featureNames.includes(feature));

  if (variant !== undefined) {
    const isRegex = variant.startsWith('/') && variant.endsWith('/');
    if (isRegex) {
      const regexBody = variant.slice(1, -1); // remove the slashes
      const regex = new RegExp(regexBody);
      conditions.push(featureVariants.some((variantInList) => regex.test(variantInList)));
    } else {
      conditions.push(featureVariants.includes(variant));
    }
  }

  return conditions.every(Boolean);
};

type GetLowestTierForFeatureReturnType = Extract<
  PlanFamily,
  PlanFamily.ULTIMATE_PLANS | PlanFamily.BASE_PLANS | PlanFamily.ENTERPRISE_PLANS | PlanFamily.FREEMIUM_PLANS
>;
export const getLowestTierForFeature = (
  feature: ProductFeature,
  variant?: string,
  options?: { skipFreemium?: boolean },
): GetLowestTierForFeatureReturnType => {
  const order = options?.skipFreemium
    ? FAMILIES_PRICING_ORDER.filter((family) => family !== PlanFamily.FREEMIUM_PLANS)
    : FAMILIES_PRICING_ORDER;
  const tier = (order as (keyof typeof FEATURE_PER_FAMILY)[]).find((family) => {
    const featureNames = FEATURE_PER_FAMILY[family].map((planFeature) =>
      planFeature.split('/').at(0),
    ) as ProductFeature[];
    const featureVariants = FEATURE_PER_FAMILY[family].map((planFeature) => planFeature.split('/').at(1)) as string[];
    return hasFeatureBase(featureNames, featureVariants, feature, variant);
  });
  return tier ?? PlanFamily.BASE_PLANS;
};
